import { Helmet } from "react-helmet-async";
import { useSettings } from "../context/SettingsContext";

export const SITE = "https://quantora.co.in";

export default function Seo({ title, description, path = "", schema, noindex = false, image }) {
  const { settings } = useSettings();
  const base = (settings?.site_url || SITE).replace(/\/$/, "");
  const full = title ? `${title} | Quantora` : "Quantora – Premium Financial Advisory & Investment Solutions";
  const desc = description || "Quantora helps individuals and businesses make smarter financial decisions with guidance on insurance, mutual funds, wealth planning and investments.";
  const schemas = Array.isArray(schema) ? schema : schema ? [schema] : [];
  return (
    <Helmet>
      <title>{full}</title>
      <meta name="description" content={desc} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large"} />
      {!noindex && <link rel="canonical" href={`${base}${path}`} />}
      <meta property="og:title" content={full} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={`${base}${path}`} />
      <meta property="og:type" content="website" />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      {settings?.google_site_verification && <meta name="google-site-verification" content={settings.google_site_verification} />}
      {settings?.bing_site_verification && <meta name="msvalidate.01" content={settings.bing_site_verification} />}
      {schemas.map((s, i) => <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>)}
    </Helmet>
  );
}

export const ORG_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "FinancialService",
  name: "Quantora",
  legalName: "Quantora Analytics Private Limited",
  url: SITE,
  email: "info@quantora.co.in",
  telephone: "+91-7070704697",
  slogan: "Your Future. Our Financial Intelligence.",
  areaServed: "IN",
};

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map(([name, path], i) => ({ "@type": "ListItem", position: i + 1, name, item: `${SITE}${path}` })),
});
